import React, { FC } from 'react';
import { Skeleton, Tag } from 'antd';
import { Longdash } from '~/utils';
import UnknownAccount from '~/pages/accounts/components/UnknownAccount';

interface TableAccountFieldProps {
  accountIds?: string[];
  accountMap?: Map<string, { id: string; number?: string }>;
  loading?: boolean;
}

const TableAccountField: FC<TableAccountFieldProps> = ({ accountIds, accountMap, loading }) => {
  if (!Array.isArray(accountIds) || accountIds.length === 0) return <>{Longdash}</>;
  if (loading) return <Skeleton.Button active size="small" style={{ height: 16, minWidth: 150 }} />;
  const firstId = accountIds[0];
  const restIds = accountIds.slice(1);
  const account = accountMap?.get(firstId);
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'flex-end',
        gap: 8,
      }}
    >
      {account ? account.number : firstId ? <UnknownAccount /> : Longdash}
      {restIds.length > 0 && <Tag>{`+${restIds.length}`}</Tag>}
    </div>
  );
};

export default TableAccountField;
